<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <b-form-checkbox v-for="(value, index) in splitValue()" :key="`DETAIL-${index}`"
            :class="value.class"
            :disabled="isReadonly"
            :checked="value.checked"
        >
            {{ value.name }}
        </b-form-checkbox>
    </div>
</template>

<script>
import AuditUtils from '@/components/pages/audit/AuditUtils.js'

export default {
    name: 'AuditNoteCheckListBox',

    props: {
        control: Object
    },

    data() {
        return {
            isReadonly: true
        };
    },

    methods: {
        splitValue() {
            const result = [];
            const valueContents = AuditUtils.splitCommaText(this.control.valueContents);
            const oldValueContents = AuditUtils.splitCommaText(this.control.oldValueContents);
            const allValues = this.control.allValues.split('\r\n').filter(x => x.length > 0);
            allValues.forEach(element => {
                const current = valueContents.indexOf(element) != -1;
                const old = oldValueContents.indexOf(element) != -1;
                if (current != old) {
                    if (this.control.status != 'DELETE') {
                        result.push({name: element, checked: current, class: 'added'});
                    }
                    if (this.control.status != 'NEW') {
                        result.push({name: element, checked: old, class: 'deleted'});
                    }
                } 
            });
            return result;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;

    .custom-control-input:disabled ~ .custom-control-label {
        color: red !important;
    }
}
.added {
    color: green !important;

    .custom-control-input:disabled ~ .custom-control-label {
        color: green !important;
    }
}
</style>